import { render, staticRenderFns } from "./addDepositTier.vue?vue&type=template&id=7bfe3848&lang=pug"
import script from "./addDepositTier.vue?vue&type=script&lang=js"
export * from "./addDepositTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports